import axios from "axios";

const BASE_API_URL = "/web/rest-fp";

export function finalizeForm(formData) {
	return axios
		.post(`${BASE_API_URL}/gps-quote-request/finalize`, formData)
		.then(result => result.data);
}